// components/PasswordPopup.js
import { useState } from 'react';

const PasswordPopup = ({ isOpen, onSuccess, onClose }) => {
  const [password, setPassword] = useState('');
  const [error, setError] = useState(false);

  const CORRECT_PASSWORD = '100318';

  const handleSubmit = (e) => {
    e.preventDefault();
    if (password === CORRECT_PASSWORD) {
      setError(false);
      setPassword('');
      onSuccess();
    } else {
      setError(true);
      setPassword('');
    }
  };

  const handleClose = () => {
    setPassword('');
    setError(false);
    onClose();
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-70 flex items-center justify-center z-[200] p-4">
      <div className="bg-gray-900 rounded-lg shadow-xl w-full max-w-sm">
        {/* Header */}
        <div className="bg-gray-800 px-6 py-4 border-b border-gray-700 rounded-t-lg">
          <h2 className="text-lg font-bold text-white text-center">
            <i className="fa fa-lock mr-2"></i>
            Admin Access
          </h2>
        </div>

        {/* Content */}
        <form onSubmit={handleSubmit} className="p-6">
          <label className="block text-gray-300 text-sm font-medium mb-2">
            Enter Password
          </label>
          <input
            type="password"
            inputMode="numeric"
            pattern="[0-9]*"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            className="w-full px-4 py-3 bg-gray-800 border border-gray-700 rounded-lg text-white text-center text-xl tracking-widest focus:outline-none focus:border-blue-500"
            placeholder="••••••"
            maxLength={6}
            autoFocus
          />
          {error && (
            <p className="mt-3 text-red-400 text-sm text-center">
              <i className="fa fa-exclamation-triangle mr-1"></i>
              Incorrect password
            </p>
          )}
          
          <div className="flex gap-3 mt-6">
            <button
              type="button"
              onClick={handleClose}
              className="flex-1 px-4 py-2 bg-gray-700 hover:bg-gray-600 text-white rounded-lg transition-colors"
            >
              Cancel
            </button>
            <button
              type="submit"
              className="flex-1 px-4 py-2 bg-blue-600 hover:bg-blue-700 text-white rounded-lg transition-colors"
            >
              Unlock
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default PasswordPopup;